import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { extractYearFromString } from "../utils";

@Injectable({ providedIn: 'root' })
export class TranslateDataKeysService {
  constructor(private translateService: TranslateService) {}

  translateKeys(data: Record<string, any>[], prefix: string): any[] {
    return data.map(row => {
      const newRow: Record<string, any> = {};

      for (const key of Object.keys(row)) {
        const year = extractYearFromString(key);
        const baseKey = year ? key.replace(year, '').trim() : key;

        const translated = this.translateService.instant(`${prefix}.${baseKey}`);
        const baseEnd = translated.startsWith(prefix) ? baseKey : translated;

        const finalKey = year ? `${baseEnd} ${year}` : baseEnd;

        newRow[finalKey] = row[key];
      }

      return newRow;
    });
  }
}
